import { FunctionComponent, memo, useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { IYearlevel_map } from "./IYearlevel_map";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { addYearlevel_map } from "../../Redux/Slices/Yearlevel_map/AddYearlevel_mapSlice";
import { EditYearlevel_map } from "../../Redux/Slices/Yearlevel_map/EditYearlevel_mapSlice";
import Select from "../../Components/Select/AutoComplete";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { listCountry } from "../../Redux/Slices/Country/ListCountrySlice";
import { listPackageDomain } from "../../Redux/Slices/Package/ListPackageDomainSlice";
interface Yearlevel_mapFormProps {
  formRef: React.RefObject<HTMLFormElement>;
  initialValues: IYearlevel_map;
  setInitialValues: React.Dispatch<React.SetStateAction<IYearlevel_map>>;
}

const Yearlevel_mapForm: FunctionComponent<Yearlevel_mapFormProps> = (
  props
) => {
  const dispatch = useAppDispatch();

  const userSchema = z.object({
    id: z.number().optional(),
    state: z.number({
      required_error: "Please select state",
      invalid_type_error: "Please select state",
    }),
    year_group: z.number({
      required_error: "Please select year group",
      invalid_type_error: "Please select year group",
    }),
    domain: z.string({
      required_error: "Please select domain",
      invalid_type_error: "Please select domain",
    }),
    status: z.boolean({
      message: "Please select the status",
    }),
  });
  const methods = useForm<IYearlevel_map>({
    defaultValues: {
      ...props.initialValues,
      state: props.initialValues?.region?.id || props.initialValues?.state,
      year_group: props.initialValues?.yeargroup?.id || props.initialValues?.year_group,
      status: props.initialValues.id ? props.initialValues.status : true,
    },
    resolver: zodResolver(userSchema),
    mode: "onChange",
  });

  const { data: listyearGroups } = useAppSelector(
    (state) => state.ListyearGroupSlice
  );

  const { data: listCountrys } = useAppSelector(
    (state) => state.ListCountrySlice
  );

  const { data: listDomains } = useAppSelector(
    (state) => state.ListPackageDomainSlice
  );
  const ListYear = Array.isArray(listyearGroups?.data)
    ? listyearGroups?.data.map((listQuestions) => ({
      label: listQuestions?.year_group!,
      value: listQuestions.id,
    }))
    : [];
  console.log(ListYear);

  const ListCountry = Array.isArray(listCountrys?.data)
    ? listCountrys?.data.map((listQuestions) => ({
      label: `${listQuestions?.region}-${listQuestions?.state}`!,
      value: listQuestions.id,
    }))
    : [];

  const ListDomain = Array.isArray(listDomains?.data)
    ? listDomains?.data.map((domain: string) => domain)
    : [];

  const onSubmit: SubmitHandler<IYearlevel_map> = (val) => {
    if (val.id) {
      dispatch(EditYearlevel_map(val));
    } else {
      dispatch(addYearlevel_map(val));
    }
  };

  useEffect(() => {
    return () => {
      props.setInitialValues({});
    };
  }, [props]);

  // Status list
  const Yearlevel_mapSatus = [
    {
      label: "Active",
      value: true,
    },

    {
      label: "Inactive",
      value: false,
    },
  ];

  return (
    <FormProvider {...methods}>
      <form
        ref={props.formRef}
        onSubmit={methods.handleSubmit(onSubmit)}
        className="form_content"
      >
        <Select
          name="year_group"
          label="Select  the year group"
          options={ListYear ?? []}
          value={
            ListYear?.find(
              (list) => list.value === methods.getValues("year_group")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("year_group", val?.value, {
              shouldValidate: true,
            });
          }}
        />
        <Select
          name="domain"
          label="Select the Domain"
          options={ListDomain ?? []}
          value={
            ListDomain?.find(
              (list: any) => list === methods.getValues("domain")
            ) ?? null
          }
          onChange={(_, value) => {
            console.log("value", value)
            const val = value as AutocompleteOption;
            methods.setValue("domain", val as string, {
              shouldValidate: true,
            });
          }}
        />
        <Select
          name="state"
          label="Select  the state"
          options={ListCountry ?? []}
          value={
            ListCountry?.find(
              (list) => list.value === methods.getValues("state")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("state", val?.value, {
              shouldValidate: true,
            });
          }}
        />

        <Select
          name="status"
          label="Status"
          options={Yearlevel_mapSatus}
          value={
            Yearlevel_mapSatus?.find(
              (role) => role.value === methods.getValues("status")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("status", val?.value, { shouldValidate: true });
          }}
        />
      </form>
    </FormProvider>
  );
};

export default memo(Yearlevel_mapForm);
